import { useQuery } from "@tanstack/react-query";
import { useIsLogged } from "../../../hooks/auth/use-is-logged/use-is-logged";
import { FetchStrategies } from "../../../features/ai-chatbot/constants/fetch-strategies.enum";
import { getActiveInChatPrompts, getActiveInPagePrompts } from "./ai-chatbot-cms-prompt.api";
import { aiChatbotCmsPromptQueryKeys } from "./ai-chatbot-cms-prompt.query-keys";
import type { IUseAiChatbotCmsPromptQuery } from "./useAiChatbotCmsPrompt.query.interface";

const CACHE_MAX_AGE_MINUTES = 30;
const CACHE_MAX_AGE_MILLIS = CACHE_MAX_AGE_MINUTES * 60 * 1_000;

const fetchStrategies = {
  [FetchStrategies.inPage]: {
    queryKey: aiChatbotCmsPromptQueryKeys.inPage(),
    queryFn: getActiveInPagePrompts,
  },
  [FetchStrategies.inChat]: {
    queryKey: aiChatbotCmsPromptQueryKeys.inChat(),
    queryFn: getActiveInChatPrompts,
  },
};

export function useAiChatbotCmsPrompt(type: FetchStrategies): IUseAiChatbotCmsPromptQuery {
  const isLogged = useIsLogged();

  const query = useQuery({
    queryKey: fetchStrategies[type].queryKey,
    queryFn: fetchStrategies[type].queryFn,
    enabled: isLogged,
    staleTime: CACHE_MAX_AGE_MILLIS,
  });

  return {
    suggestedPrompts: isLogged ? query.data ?? [] : [],
    isLoading: query.isLoading && query.fetchStatus !== "idle",
    error: (query.error as Error) ?? undefined,
  };
}
